export function buildValidationKey(sun: string, property: string): string {
    return `${property}.${sun}`;
}

export function scrapValidationKeyParts(validationKey: string): { sun: string; property: string} {
    const dotIdx = validationKey.indexOf('.');
    return {
        sun: validationKey.substring(0, dotIdx),
        property: validationKey.substring(dotIdx + 1, validationKey.length - 1)
    };
}
